import { render, staticRenderFns } from "./AddNewCompany.vue?vue&type=template&id=258f3028&scoped=true&"
import script from "./AddNewCompany.vue?vue&type=script&lang=js&"
export * from "./AddNewCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f3028",
  null
  
)

export default component.exports